import { useState, useEffect } from "react";
import { Modal, Button, Radio } from "antd";

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'props' implicitly has an 'any' type.
export function InstantPayStatusModal(props) {
  const { visible, onCancel, value, onSubmit, loading } = props;
  const textStyle = {
    color: "#707070",
  };
  const radioStyle = {
    display: "flex",
    color: "#707070",
  };
  const radioWrapStyle = {
    marginTop: "10px",
    marginBottom: "10px",
  };
  const buttonStyle = {
    marginTop: "10px",
    marginBottom: "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  const [option, setOption] = useState(value);
  const [actualValue, setActualValue] = useState(value);

  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'e' implicitly has an 'any' type.
  const onOptionChangeHandler = (e) => {
    const selectedOption = e.target.value;
    setOption(selectedOption);
  };
  const onSave = () => {
    if (option !== actualValue) {
      onSubmit(option);
      return;
    }
    onCancel();
  };

  useEffect(() => {
    setOption(value);
    setActualValue(value);
  }, [value]);

  return (
    <div>
      <Modal
        visible={visible}
        title={<b>{`InstantPay Status: ${option}`}</b>}
        onCancel={onCancel}
        footer={null}
      >
        <>
          <p style={textStyle}>
            The InstantPay status of this workplace indicates if eligible HCPs (those that use
            Stripe are not prohibited from the program and clock in with the app) receive InstantPay
            when the shift is complete.
          </p>
          <Radio.Group onChange={onOptionChangeHandler} value={option} buttonStyle="solid">
            <div style={radioWrapStyle} id="instantBookRadio">
              <Radio style={radioStyle} value="ON">
                <b>ON</b>
              </Radio>
              <Radio style={radioStyle} value="OFF">
                <b>OFF</b>
              </Radio>
            </div>
          </Radio.Group>

          <div style={buttonStyle}>
            <Button key="submit" type="primary" loading={loading} onClick={onSave}>
              Submit InstantPay Status
            </Button>
          </div>
        </>
      </Modal>
    </div>
  );
}
